import { render, staticRenderFns } from "./OpenDataAddress.vue?vue&type=template&id=4d16fc20&"
import script from "./OpenDataAddress.vue?vue&type=script&lang=js&"
export * from "./OpenDataAddress.vue?vue&type=script&lang=js&"
import style0 from "./OpenDataAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports